export const SURVEYS_FILLED_COUNT_BEFORE_DISCOUNT = 10
export const DISCOUNT_RATE = 25
export const PROMO_CODE = 'SWAPPY'
